import React from 'react';
import { FiArrowUp } from 'react-icons/fi';
import './SortFilter.css';

const SortFilter = ({ sortBy, onSortChange }) => {
  const sortOptions = [
    { value: 'relevance_score:desc', label: 'Relevance' },
    { value: 'publication_date:desc', label: 'Publication Date' },
    { value: 'cited_by_count:desc', label: 'Citations' },
    { value: 'publication_date:asc', label: 'Oldest First' },
  ];

  const handleSortChange = (value) => {
    onSortChange(value);
  };

  return (
    <div className="sort-filter-container">
      <div className="sort-label">
        <FiArrowUp className="sort-icon" />
        <span>Sort by</span>
      </div>
      <div className="sort-options">
        {sortOptions.map((option) => {
          const isActive = sortBy === option.value;
          return (
            <button
              key={option.value}
              className={`sort-option ${isActive ? 'active' : ''}`}
              onClick={() => handleSortChange(option.value)}
            >
              {option.label}
              {isActive && <span className="sort-indicator">✓</span>}
            </button>
          );
        })}
      </div>
    </div>
  );
};

export default SortFilter;

